/* eslint-disable no-extend-native */
import 'fast-text-encoding';

if (!Array.prototype.toSorted) {
    Array.prototype.toSorted = function (compareFn) {
        return [...this].sort(compareFn);
    };
}
if (!Array.prototype.toReversed) {
    Array.prototype.toReversed = function () {
        return [...this].reverse();
    };
}

if (!Array.prototype.toSpliced) {
    Array.prototype.toSpliced = function (start, deleteCount, ...items) {
        const copy = [...this];
        copy.splice(start, deleteCount, ...items);
        return copy;
    };
}
